import { load } from '@progress/kendo-react-intl'

import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import weekData from 'cldr-core/supplemental/weekData.json'

import numbers from 'cldr-numbers-full/main/ja/numbers.json'
import currencies from 'cldr-numbers-full/main/ja/currencies.json'
import caGregorian from 'cldr-dates-full/main/ja/ca-gregorian.json'
import dateFields from 'cldr-dates-full/main/ja/dateFields.json'
import timeZoneNames from 'cldr-dates-full/main/ja/timeZoneNames.json'

export class Localizer {
  static loadResources(): void {
    load(
      likelySubtags,
      currencyData,
      weekData,
      numbers,
      currencies,
      caGregorian,
      dateFields,
      timeZoneNames)
  }
}
